import React, { SVGProps } from 'react';

export const TrashNewIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M22.5 5.1h-5.826C16.386 1.162 14.172.6 12 .6c-2.172 0-4.386.562-4.674 4.5H1.5v1.8h2.18l1.143 12.258a3.897 3.897 0 0 0 3.872 3.492H15.303a3.894 3.894 0 0 0 3.873-3.486l.002-.016L20.317 6.9H22.5V5.1ZM12 2.4c1.414 0 2.64.03 2.862 2.7H9.138C9.36 2.43 10.586 2.4 12 2.4Zm5.388 16.568a2.098 2.098 0 0 1-2.084 1.882H8.695a2.093 2.093 0 0 1-2.08-1.86v-.01L5.49 6.9h13.024l-1.127 12.068Z"
      />
    </svg>
  );
};
